import { MyStore } from './my'
import { AuthStore } from './auth'
import { MarketStore } from './market'
import { ArtfairStore } from './artfair'
import { NotificationStore } from './notification'
import { HomeStore } from './home'
import { CommonStore } from './common'

class rootStore {
  static instance: rootStore
  commonStore: CommonStore
  authStore: AuthStore
  marketStore: MarketStore
  myStore: MyStore
  artfairStore: ArtfairStore
  notificationStore: NotificationStore
  homeStore: HomeStore

  constructor() {
    this.commonStore = new CommonStore(this)
    this.authStore = new AuthStore(this)
    this.marketStore = new MarketStore(this)
    this.myStore = new MyStore(this)
    this.artfairStore = new ArtfairStore(this)
    this.notificationStore = new NotificationStore(this)
    this.homeStore = new HomeStore(this)
  }
}
export default rootStore
